export const CHECK_SURGERY_CLASSIFICATION_ID = 'check-surgery-classification';
export const VIEW_BENEFIT_SCHEDULE_ID = 'view-benefit-schedule';

export enum BENEFIT_SECTION_ID {
  OUTPATIENT = 'OP',
  HOSPITALISATION_SURGICAL = 'HOSP',
  SUPPLEMENTARY_MAJOR_MEDICAL = 'SMM',
  DENTAL = 'DEN',
  MATERNITY = 'MAT',
  WORLDWIDE_EMERGENCY_ASSISTANCE = 'EAB',
}
